import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcBackWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 4L7 12L16 20",
		stroke: "white",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcBackWhite;
